var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.6049C21.6959 26.187 22.2868 25.8268 22.8828 25.4751L38.6311 16.1956C39.1305 15.9017 39.1638 15.9085 39.4634 16.4267C42.4233 21.5495 45.3837 26.6728 48.3447 31.7968C48.6677 32.3557 48.666 32.3625 48.1067 32.6938C45.508 34.2228 42.9027 35.7519 40.3108 37.3047C40.1392 37.4297 39.9341 37.4978 39.7233 37.4999C39.5125 37.5021 39.3061 37.4381 39.1321 37.3166C33.2978 33.8678 27.458 30.4297 21.6126 27.0024C21.4378 26.9005 21.2713 26.7816 21 26.6049Z",
    fill: "url(#paint0_linear_2187_41958)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2097 49.2056C39.2097 52.5543 39.2097 55.9018 39.2097 59.2482C39.2097 59.3331 39.2097 59.418 39.2097 59.503C39.1984 60.0618 39.1142 60.1145 38.6544 59.8342C33.1976 56.5263 27.742 53.2202 22.2875 49.9157C21.9507 49.7118 21.9037 49.5386 22.1012 49.1886C24.9543 44.0994 27.8019 39.0074 30.6442 33.9125C30.934 33.4029 30.9453 33.4029 31.4538 33.7087C33.855 35.1627 36.2531 36.6253 38.6641 38.0624C38.8389 38.1466 38.9848 38.2852 39.0821 38.4592C39.1794 38.6333 39.2234 38.8345 39.2081 39.0357C39.1935 42.433 39.2081 45.8151 39.2081 49.2056H39.2097Z",
    fill: "url(#paint1_linear_2187_41958)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8987 37.7182C58.8987 40.9156 58.8987 44.1131 58.8987 47.3105C58.8987 47.9848 58.8753 48 58.2296 48H40.8646C40.2172 48 40.1955 47.9747 40.1955 47.3038C40.1955 44.4716 40.2122 42.1394 40.2055 39.3072C40.1888 39.1215 40.2291 38.935 40.3209 38.7731C40.4128 38.6112 40.5517 38.4816 40.719 38.4019C46.1589 35.255 51.5937 32.0958 57.0236 28.9242C57.507 28.6427 57.9904 28.3662 58.4722 28.0813C58.7549 27.9127 58.887 28.0122 58.8954 28.3257C58.8954 28.4808 58.8954 28.6342 58.8954 28.7893V37.7114L58.8987 37.7182Z",
    fill: "url(#paint2_linear_2187_41958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4065 49.1798L40.2734 60C40.2371 59.7875 40.211 59.5732 40.1955 59.358C40.1955 56.1119 40.1955 52.8653 40.1955 49.6181C40.1955 49.0531 40.2452 49 40.7842 49C46.5091 49 52.2334 49.0034 57.9571 49.0103C58.0988 49.0192 58.24 49.0358 58.38 49.0599L58.4065 49.1798Z",
    fill: "url(#paint3_linear_2187_41958)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0323 48.9613C21.021 48.7931 21 48.6416 21 48.4818C21 41.8505 21.0065 35.2192 21.0194 28.5879C21.0194 28.5593 21.0194 28.5324 21.0194 28.5038C21.0291 27.9368 21.1065 27.8847 21.5649 28.1673C23.0714 29.077 24.5811 29.9878 26.0941 30.8997C27.2449 31.5929 28.3909 32.2945 29.5531 32.9658C29.9179 33.1761 29.9292 33.3746 29.7322 33.7263C26.9345 38.7121 24.1367 43.7035 21.339 48.7005C21.2792 48.8048 21.205 48.9007 21.1388 49L21.0323 48.9613Z",
    fill: "url(#paint4_linear_2187_41958)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4065 26.7293C58.1871 26.8911 58.0791 26.9875 57.9481 27.0632C55.3565 28.64 52.7639 30.2145 50.1701 31.7867C49.6445 32.1034 49.6429 32.1017 49.3301 31.5474C46.5257 26.5738 43.7219 21.6008 40.9185 16.6283C40.8285 16.4665 40.7646 16.284 40.6877 16.1119L40.7924 16L58.4065 26.7293Z",
    fill: "url(#paint5_linear_2187_41958)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7563 42.3762L73.1723 45.0664C74.3071 48.851 77.946 51.3377 82.6749 51.3377C88.0522 51.3377 92.2913 48.181 92.2913 42.8251C92.2913 37.7884 88.6593 35.9435 84.5237 34.9263L83.6062 34.7019C80.802 34.0004 78.9704 33.3304 78.9704 31.5942C78.9704 30.1913 80.288 29.2758 82.1748 29.2758C84.5064 29.2758 85.8758 30.6122 86.2552 32.7552L86.6794 32.8955L90.7736 30.4929C89.6837 27.3818 86.8553 25.2598 82.2472 25.2598C77.4183 25.2598 73.8035 27.7571 73.8035 31.9239C73.8035 34.9544 75.5488 36.7257 78.2116 37.8691C79.184 38.2762 80.1876 38.6011 81.2124 38.8407C81.8367 38.9915 82.4403 39.1388 82.9991 39.3001C85.2963 39.9595 86.9485 40.861 86.9485 43.1899C86.9485 45.5189 85.2721 46.7745 82.9577 46.7745C80.4501 46.7745 78.5082 45.2944 78.1288 42.4954L77.7563 42.3762Z",
    fill: "#0C2C54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.465 47.1286C111.246 47.2165 111.011 47.2548 110.776 47.2409C109.993 47.2409 109.493 46.6972 109.493 45.5363V39.0545C109.493 34.7789 106.288 32.499 101.904 32.499C98.1998 32.499 95.2783 34.3825 94.5298 38.0759L94.7092 38.2933L98.9103 38.6441C99.1242 37.1254 100.159 36.1468 101.832 36.1468C103.684 36.1468 104.753 37.0868 104.753 38.7528V39.5701L99.9555 40.0681C96.1096 40.4645 93.6882 42.4918 93.6882 45.8239C93.6882 49.2682 96.3234 51.3341 99.3484 51.3341C101.735 51.3341 103.374 50.3555 104.943 48.721H105.191C106.009 50.573 107.578 51.1763 109.182 51.1763C110.014 51.1958 110.844 51.0773 111.638 50.8255V47.3461L111.465 47.1286ZM104.784 44.8313C103.501 46.5008 102.294 47.4794 100.511 47.4794C99.2656 47.4794 98.3033 46.7533 98.3033 45.5222C98.3033 44.2911 99.1932 43.4563 100.866 43.2389L104.784 42.7443V44.8313Z",
    fill: "#0C2C54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.298 32.8604H113.311V50.9694H118.298V32.8604Z",
    fill: "#0C2C54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.822 25C115.251 24.9993 114.692 25.171 114.217 25.4933C113.741 25.8156 113.371 26.2741 113.152 26.8107C112.933 27.3472 112.875 27.9378 112.987 28.5076C113.098 29.0774 113.373 29.6008 113.777 30.0116C114.181 30.4224 114.696 30.7021 115.256 30.8153C115.816 30.9284 116.397 30.87 116.925 30.6473C117.452 30.4247 117.903 30.0479 118.22 29.5646C118.537 29.0813 118.706 28.5132 118.705 27.9322C118.696 27.1574 118.39 26.4168 117.851 25.8689C117.312 25.321 116.584 25.0091 115.822 25Z",
    fill: "#0C2C54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.063 37.0623V45.3925C128.063 46.5886 128.777 47.2024 129.984 47.2024C130.471 47.1919 130.953 47.1019 131.412 46.9358L131.661 47.0831V50.9413C130.635 51.1925 129.583 51.3104 128.529 51.2921C125.355 51.2921 123.11 49.626 123.11 45.7889V37.0202H119.961V32.8112H123.127V28.3638L127.611 25.7227H128.07V32.8603H131.847V37.0693L128.063 37.0623Z",
    fill: "#0C2C54"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.229 32.499C136.565 32.499 132.54 36.5186 132.54 41.913C132.54 47.3075 136.565 51.3341 142.229 51.3341C147.893 51.3341 151.952 47.311 151.952 41.913C151.952 36.5151 147.927 32.499 142.229 32.499ZM142.229 46.9498C139.521 46.9498 137.528 45.0627 137.528 41.913C137.528 38.7633 139.521 36.8798 142.229 36.8798C144.937 36.8798 146.965 38.7633 146.965 41.913C146.965 45.0627 144.933 46.9357 142.229 46.9357V46.9498Z",
    fill: "#0C2C54"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2187_41958",
    x1: 34.7814,
    y1: 16,
    x2: 45.8651,
    y2: 34.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F71F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2187_41958",
    x1: 33.0587,
    y1: 35.5,
    x2: 36.2198,
    y2: 49.7367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F71F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF883E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2187_41958",
    x1: 51.762,
    y1: 31.5,
    x2: 60.2806,
    y2: 45.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F71F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2187_41958",
    x1: 40.1955,
    y1: 54.5,
    x2: 57.0522,
    y2: 52.9135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F71F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2187_41958",
    x1: 25.4297,
    y1: 28,
    x2: 33.6876,
    y2: 37.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F71F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2187_41958",
    x1: 49.5471,
    y1: 16,
    x2: 58.3141,
    y2: 28.7075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F71F3D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaito);
export default __webpack_public_path__ + "static/media/saito.6ccda4f49f0cc9185c6974268308dc24.svg";
export { ForwardRef as ReactComponent };